







































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListSoko from '@/components/common/search/ListSoko.vue';
import { API_SEARCH_SOKO } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlSoko',
  components: {
    CtrlSearchBtn,
    CtrlNumTxt,
    ListSoko,
  },
  props: {
    jigyoshoCd: {
      type: Number,
      default: null,
    },
    jigyoshoHenkoFlg: {
      type: Boolean,
      default: false,
    },
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '倉庫',
    },
    widthCd: {
      type: Number,
      default: 45, //32,
    },
    widthName: {
      type: Number,
      default: 255,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_SOKO,
    listSokoShow: false,
    sokoCd: 0,
    sokoRyakuMei: '',
    errors: {
      errorMessages: '',
    },
    isChangeValue: false,
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { sokoCd, sokoRyakuMei } = item;
      this.sokoCd = sokoCd;
      this.sokoRyakuMei = sokoRyakuMei;
      this.listSokoShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listSokoShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.sokoCd = +value;
      if (value) {
        this.getSokoItem();
      } else {
        this.sokoRyakuMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ sokoCd: this.sokoCd });
      }
    },
    getSokoItem() {
      axios
        .get(API_SEARCH_SOKO, {
          params: {
            sokoCd: this.sokoCd,
            mukoUmuFlg: this.mukoUmuFlg,
            jigyoshoCd: this.jigyoshoCd,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.sokoRyakuMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk && this.callbackOk({ sokoCd: this.sokoCd });
            return;
          }
          this.errors = clearNoDataError();
          const { sokoRyakuMei } = res.data.responseData[0];
          this.sokoRyakuMei = sokoRyakuMei;
          if (this.callbackOk) {
            this.callbackOk(res.data.responseData[0]);
          }
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [sokoCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.sokoCd': {
      handler(newValue) {
        if (+newValue === +this.sokoCd) return;
        this.sokoCd = +newValue;
        if (newValue) {
          this.getSokoItem();
        } else {
          this.sokoRyakuMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.sokoCd) {
      this.sokoCd = +this.$attrs.sokoCd;
    }
  },
});
